import{gql as t}from"@apollo/client";const e=t`
  query getGeladaSettings($projectId: String!) {
    settings {
      list {
        service
        type
        value(projectId: $projectId)
        inputType
        dataType
        description
        section
      }
    }
  }
`;export{e as GET_SETTINGS};
//# sourceMappingURL=useGetSettings.graphql.js.map
